import React from 'react';

const ElevatTerms = () => (
    <div>
      <p>
        <strong>Effective May 1, 2018</strong>
      </p>
      <p>
        <strong>
          PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE
          ELEVAT-IOT WEBSITE OR SERVICE (THE “SERVICE”). IF YOU USE OR ACCESS
          THE SERVICE, YOU WILL BE BOUND BY THESE TERMS.
        </strong>
        <br />
        <br />
        By using and accessing the Service, you agree to be bound by these User
        Terms of Service (&quot;Terms&quot;). To access the Service, you must
        accept and agree to be bound by the Terms. If you do not agree to all of
        these Terms, do not use the Service.
      </p>
      <p>
        Elevat, Inc. (&quot;Elevat&quot;) may amend these Terms at any time by
        making the revised Terms available at our websites{' '}
        <a href="http://www.elevat-iot.com">www.elevat-iot.com</a> or{' '}
        <a href="https://protect-us.mimecast.com/s/DzxkBphXQmpfr?domain=app.elevat-iot.com">
          https://app.elevat-iot.com/
        </a>{' '}
        with an updated effective date. Your continued use of the Service will
        constitute your acceptance of the Terms as amended.
      </p>
      <p>
        By using the Service, you also agree to be bound by the Privacy Policy
        located <a href="http://www.elevat-iot.com/privacypolicy">here</a> in
        its then-current form.
        <strong />
      </p>
      <p>
        <strong>1. </strong>
        <strong>User Obligations</strong>
      </p>
      <p>
        <strong>
          When creating an account or when using the Service, you agree to:{' '}
        </strong>
        (1) provide accurate information to us at all times and promptly update
        any information provided, including your profile or any other account
        information; (2) keep your access credentials confidential and secure
        and to promptly notify us if they are compromised; and (3) promptly
        update any compromised credentials to new credentials and take other
        steps that you or we may deem necessary to protect your account.
      </p>
      <p>
        You are responsible for any inaccurate information you provide in
        connection with the Service and any actions taken under your account
        credentials, regardless of whether such actions are taken by you or a
        third party. We are not liable for any loss or damage arising from any
        unauthorized use of your account.
      </p>
      <p>
        <strong>2. </strong>
        <strong>User Qualifications</strong>
      </p>
      <p>
        <strong>
          You represent and warrant that you (1) are at least 18 years of age
          and a resident of the US, if you are an individual, (2) are legally
          and validly organized under US law, if you are an organization or
          entity, and (3) have the authority to enter into legally binding
          contracts for yourself or your legal entity under applicable law.
        </strong>
        <strong />
      </p>
      <p>
        <strong>3. </strong>
        <strong>User Information and Data</strong>
      </p>
      <p>
        When setting up an account on the Service, you will submit certain
        information necessary to create an account with Elevat (“User
        Information”). Other than as specifically requested by Elevat to
        establish your account, or retrieved by Elevat in the normal course of
        your use of the Service, you will not submit any personally identifiable
        information to Elevat at any time.
      </p>
      <p>
        By accessing and using the Service, you agree and consent to collection
        of certain information by the Service, and to the storage and use, of
        such information by Elevat, in its discretion. Notwithstanding any other
        provision of these Terms, all information that is collected from you by
        Elevat and all information that you share, transmit, or otherwise make
        available to Elevat, including all personally identifiable information
        which has been de-identified data, constitutes “Data”; provided however,
        that “Data” does not include personally identifiable information.
      </p>
      <p>
        You grant us and our affiliates and related entities, a worldwide,
        royalty-free, perpetual, irrevocable, non-exclusive right and fully
        sub-licensable license to use, copy, reproduce, distribute, publish,
        publicly perform, publicly display, modify, adapt, translate, archive,
        store, and create derivative works from all Data, in any form, format,
        or medium, of any kind now known or later developed. You waive any moral
        rights you might have with respect to any Data. You also grant us the
        right to use any material, information, ideas, concepts, know-how or
        techniques contained in any Data for any purpose whatsoever, including
        but not limited to, commercial purposes, and developing, manufacturing
        and marketing commercial products using such information. We may also
        aggregate Data with other information in such a way that it will not
        identify you and we may use that aggregated Data to develop and improve
        our products and services. All rights in this paragraph are granted
        without the need for us to pay compensation of any sort to you.
      </p>
      <p>
        You agree that any materials, including but not limited to questions,
        comments, suggestions, ideas, plans, notes, drawings, original or
        creative materials or other information regarding us or the Service that
        you provide to us, whether in email, feedback forms, or other submission
        format, shall belong exclusively to us, without acknowledgement or
        compensation to you.
      </p>
      <p>
        In addition, we may use or disclose any Data or other information that
        we reasonably believe is necessary to: (1) satisfy legal requirements or
        governmental requests; (2) enforce or investigate violations of these
        Terms; (3) detect, prevent, or otherwise address fraud, security, or
        technical issues; (4) respond to your user support requests; (5) protect
        the rights, property, or safety of Elevat, our users, and the public.
      </p>
      <p>
        <strong>4. </strong>
        <strong>Prohibited Uses</strong>
      </p>
      <p>
        <strong />
      </p>
      <p>
        <strong>
          You agree not to engage in any of the following activities while using
          or accessing the Service and you acknowledge and agree that violating
          these prohibitions constitutes a breach of these Terms:
        </strong>
        <strong />
      </p>
      <p>• Violating local, state, or other applicable laws or regulations;</p>
      <p>
        • Posting content that infringes the intellectual property rights,
        privacy, publicity, or other rights of any third party;
      </p>
      <p>
        • Posting content that is unlawful, obscene, defamatory, threatening,
        harassing, hateful, or embarrassing to any party as determined in our
        sole discretion;
      </p>
      <p>
        • Impersonating a third party or implying you are someone other than who
        you are;
      </p>
      <p>• Distributing viruses or other harmful or malicious computer code;</p>
      <p>
        • Collecting information about others without their explicit written
        consent;
      </p>
      <p>
        • Providing your access credentials or otherwise allowing a third party
        or third party system to use your identification, to pretend they are
        you, or to access your account; or
      </p>
      <p>
        • Engaging in any conduct that disrupts or impedes a third party&#39;s
        use and enjoyment of the Service, or which, in our judgment, exposes us
        or any customers, partners or related entities to liability or detriment
        of any type.
      </p>
      <p>
        <strong>5. </strong>
        <strong>Limited License to Use Service</strong>
      </p>
      <p>
        Elevat grants you limited, revocable, non-sublicensable license to
        access and use the Service and all content, data, information, and
        materials included by Elevat in the Service (the &quot;Elevat
        Materials&quot;) solely for your own personal use, or if you are a
        commercial customer, solely for your internal business use, subject to
        the terms and conditions set forth in these Terms. All other rights are
        reserved. You agree that you will not modify, copy, distribute, resell,
        transmit, display, perform, reproduce, publish, license, create
        derivative works from, frame in another web page, or use the Service or
        Elevat Materials except as explicitly authorized in these Terms. You
        will not use the Service or any of the Elevat Materials other than for
        their intended purpose or in any way that is unlawful or harms us or our
        suppliers.
      </p>
      <p>
        Without limiting the foregoing, you may not engage or attempt to engage
        in the practices of &quot;screen scraping,&quot; &quot;database
        scraping,&quot; &quot;data mining&quot; or any other activity with the
        purpose of obtaining lists of users or other information from the
        Service or that uses web &quot;bots&quot; or similar data gathering or
        extraction methods, or knowingly permit use of your access credentials
        by another party to do so. You may not obtain or attempt to obtain any
        materials or information through any means not intentionally made
        available or provided for through the Service.
      </p>
      <p>
        <strong>6. </strong>
        <strong>Suspension and Termination</strong>
        <strong />
      </p>
      <p>
        Elevat can, in its sole discretion, suspend access to your account on
        the Service if we believe: (1) there is risk to the security or privacy
        of your account; (2) there is a threat to the security or integrity of
        our network or the Service; (3) suspension is needed to protect the
        rights, property or safety of Elevat, our users or the public; (4) there
        is a basis for termination of your account; or (5) you have violated
        these Terms; or (6) we are required to by law.
      </p>
      <p>
        We may cancel your access to the Service: (1) immediately if you breach
        these Terms; (2) there is a basis for cancellation of your account based
        on another agreement in place between us; or (2) if required by law. We
        will provide you notice if we cancel your account.
      </p>
      <p>
        We will endeavor to promptly provide you notice in the event of any
        suspension or termination. During a suspension or following a
        termination, you will not have the ability to use or access the Service
        and other information contained or stored by you in, or as part of, the
        Service will no longer be accessible to you. Any suspension of your
        access to the Service will not limit or waive our rights to terminate
        your access to the Service. At the point we determine, in our sole
        discretion, that the reason for suspension of access to your account has
        been resolved, we will restore access to your account. During a
        suspension or following a termination, you will not register or attempt
        to register another account with Elevat.
      </p>
      <p>
        These Terms terminate upon cancellation of your account. Upon
        termination, Elevat has no obligation to store your data, but may do so
        to comply with legal or business requirements for a reasonable time
        after termination.
      </p>
      <p>
        <strong>
          You may cancel your account at any time by emailing
          cancel@elevat-iot.com.
        </strong>
        <strong />
      </p>
      <p>
        <strong />
      </p>
      <p>
        <strong>7. </strong>
        <strong>Disclaimer of Warranty and Limitation of Liability</strong>
      </p>
      <p>
        YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT YOUR USE OF THE SERVICE IS AT
        YOUR OWN RISK. THE SERVICE IS PROVIDED &quot;AS IS&quot;, WITHOUT
        WARRANTIES OF ANY KIND. ELEVAT, TO THE FULLEST EXTENT ALLOWED BY THE
        LAW, EXPRESSLY DISCLAIMS ANY / ALL WARRANTIES, EITHER EXPRESS OR
        IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO THE
        IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, NON-INFRINGEMENT, AND
        FITNESS FOR PARTICULAR PURPOSE. ELEVAT SHALL HAVE ABSOLUTELY NO
        LIABILITY IN CONNECTION WITH THE SERVICE INCLUDING WITHOUT LIMITATION,
        ANY LIABILITY FOR DAMAGE TO YOUR COMPUTER HARDWARE, SOFTWARE, LOSS OF
        DATA, LOSS OF BUSINESS, INABILITY TO ACCESS DATA OR THE SERVICE, OR THE
        LACK OF INFORMATION IN ANY WAY RELATING TO THE SERVICE. WHILE WE ATTEMPT
        TO ENSURE THAT YOUR ACCESS TO AND USE OF THE SERVICE IS SAFE, RELIABLE,
        AND ERROR-FREE, ELEVAT CANNOT GUARANTEE, AND DOES NOT REPRESENT OR
        WARRANT THAT THE SERVICE, OR ANY ELEMENT THEREOF, INCLUDING SOFTWARE OR
        SYSTEMS ARE AVAILABLE OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
      </p>
      <p>
        IN NO EVENT WILL ELEVAT’S TOTAL LIABILITY TO YOU FOR ALL DAMAGES ARISING
        FOR YOUR USE OF THE SERVICE OR INFORMATION, MATERIALS, OR PRODUCTS MADE
        AVAILABLE TO YOU THROUGH THE SERVICE EXCEED THE GREATER OF $100 OR THE
        AMOUNT YOU PAID TO ELEVAT FOR THE AFFECTED MATERIALS. IN NO EVENT WILL
        ELEVAT BE LIABLE FOR ANY SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES,
        PERSONAL INJURY/WRONGFUL DEATH, LOST PROFITS, OR DAMAGES RESULTING FROM
        LOST DATA OR BUSINESS INTERRUPTION RESULTING FROM THE ACCESS TO, USE OF,
        OR RELIANCE ON, THE SERVICE, APPS OR IN-APP PRODUCTS WHETHER BASED ON
        WARRANTY, CONTRACT, TORT OR ANY OTHER LEGAL THEORY, WHETHER OR NOT
        ELEVAT IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THESE LIMITATIONS
        WILL APPLY TO YOU EVEN IF THE REMEDIES FAIL OF THEIR ESSENTIAL PURPOSE.
      </p>
      <p>
        <strong />
      </p>
      <p>
        <strong>8. </strong>
        <strong>Indemnity</strong>
      </p>
      <p>
        You agree to defend, indemnify and hold Elevat, its officers, directors,
        employees, agents, licensors and business partners, harmless from and
        against any claims, actions or demands, liabilities and settlements
        including without limitation, reasonable legal and accounting fees,
        resulting from, or alleged to result from, your violation of these
        Terms.
      </p>
      <p>
        <strong>9. </strong>
        <strong>Geographic Restrictions</strong>
      </p>
      <p>
        Elevat is based in the United States of America. Elevat makes no claims
        that the Service is appropriate or may be used outside of the United
        States. Access to and use of the Service is intended solely for persons
        residing in the United States and may not be legal by certain persons or
        in certain countries. If you use the Service from outside the United
        States, you do so at your own risk and are responsible for compliance
        with the laws of your jurisdiction.
      </p>
      <p>
        <strong>10. </strong>
        <strong>Jurisdiction and Venue</strong>
      </p>
      <p>
        These Terms are governed by and construed in accordance with the laws of
        the State of Washington, without regard to its conflict of law
        principles. You expressly agree that exclusive jurisdiction for any
        dispute with Elevat, or in any way relating to the Service, resides in
        the state and federal courts in Seattle, Washington, and you hereby
        expressly, irrevocably, and unconditionally consent and submit to the
        exercise of personal jurisdiction by such courts.
      </p>
      <p>
        <strong>11. </strong>
        <strong>General</strong>
      </p>
      <p>
        If any part of the Terms is determined to be invalid or unenforceable
        pursuant to applicable law, then the invalid or unenforceable provision
        will be deemed superseded by a valid, enforceable provision that most
        closely matches the intent of the original provision and the remainder
        of the Terms will continue in effect. You may not assign these Terms, or
        assign, transfer or sublicense your rights, if any, in the Service,
        however, Elevat may freely assign these Terms. Unless expressly stated
        in another written agreement between you and us, the Terms constitute
        the entire agreement between you and us with respect to the Service. You
        agree and consent to receive communications from us via each of the
        following methods: by posting or making available such communication
        within the Service or by sending such communication to the email address
        you provided as part of your account. You agree that all agreements,
        notices, disclosures and other communications that we may provide to you
        electronically satisfy any legal requirement that such communications be
        in writing.
      </p>
    </div>
  );

export default ElevatTerms;
